"use strict";

define('model/flag',['require','exports','module','underscore','./base'],function (require, exports, module) {
  var _ = require('underscore');
  var BaseModel = require('./base');
  module.exports = BaseModel.extend({
    urlRoot: '/rs/api/type/flag'
  }, {
    POPULATION: 'Population',
    ADDITIONAL: 'Additional',
    getDescription: function getDescription(flagModel) {
      return flagModel.get('description');
    },
    Collection: BaseModel.Collection.extend({
      comparator: 'description',
      getFlagsNotInCategory: function getFlagsNotInCategory(category) {
        return this.filter(function (flag) {
          return flag.get('category') !== category;
        });
      },
      isolateCollectionToCategory: function isolateCollectionToCategory(category) {
        this.remove(this.getFlagsNotInCategory(category));
      }
    })
  });
});

